var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ThemeProviderCore, ThemeContext as ThemeContextCore, defaultContext, breakPointOrder, } from '@core-front/theme-provider';
const ThemeContext = React.createContext(Object.assign(Object.assign({}, defaultContext), { brand: 'telia', theme: 'light' }));
const breakPoints = {
    xs: 320,
    sm: 600,
    md: 800,
    lg: 1000,
    xl: 1288,
    xxl: 1450,
};
const media = {
    width: {
        xs: {
            min: '20rem',
            max: '37.499rem',
        },
        sm: {
            min: '37.5rem',
            max: '49.999rem',
        },
        md: {
            min: '50rem',
            max: '62.499rem',
        },
        lg: {
            min: '62.5rem',
            max: '80.499rem',
        },
        xl: {
            min: '80.5rem',
            max: '90.624rem',
        },
        xxl: {
            min: '90.625rem',
        },
    },
};
const ThemeProvider = (props) => {
    const { brand = 'telia', theme = 'light', root } = props, rest = __rest(props, ["brand", "theme", "root"]);
    useGlobalThemeAttributes(Object.assign({ brand, theme, root }, rest));
    /* istanbul ignore next */
    const defaultPortalRoot = typeof window !== 'undefined' ? document.body : null;
    return (React.createElement(ThemeProviderCore, Object.assign({ portalRoot: defaultPortalRoot }, rest, { breakPoints: breakPoints, media: media }),
        React.createElement(ThemeContextCore.Consumer, null, (value) => {
            return (React.createElement(ThemeContext.Provider, { value: Object.assign(Object.assign({}, value), { brand,
                    theme }) }, props.children));
        })));
};
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
const useGlobalThemeAttributes = ({ brand, theme, root: rootProp, portalRoot }) => {
    useIsomorphicLayoutEffect(() => {
        let root = rootProp;
        // if root prop is set to null, it is intentional and should not default to <html>
        if (root === undefined) {
            root = document.documentElement;
        }
        if (!root) {
            return;
        }
        const originalBrand = root.dataset.brand;
        const originalTheme = root.dataset.theme;
        root.dataset.brand = brand;
        root.dataset.theme = theme;
        return () => {
            if (!root) {
                return;
            }
            root.dataset.brand = originalBrand;
            root.dataset.theme = originalTheme;
        };
    }, [brand, theme, rootProp]);
    useIsomorphicLayoutEffect(() => {
        const root = portalRoot;
        if (!root || root === rootProp) {
            return;
        }
        const originalBrand = root.dataset.brand;
        const originalTheme = root.dataset.theme;
        root.dataset.brand = brand;
        root.dataset.theme = theme;
        return () => {
            if (!root) {
                return;
            }
            root.dataset.brand = originalBrand;
            root.dataset.theme = originalTheme;
        };
    }, [brand, theme, portalRoot, rootProp]);
};
export const useTheme = () => {
    return React.useContext(ThemeContext);
};
export { ThemeProvider as default, ThemeContext, breakPoints, media, breakPointOrder, };
